import { createStore, combineReducers } from 'redux'
import { connect } from 'react-redux';
import app, { updateAppID } from './app.js';
import stores, { updateStoreList, updateStoreQuery } from './stores.js';
import auth, { updateAuthInfo, cleanAuthInfo } from './auth.js';
import user, { updateUserInfo, cleanUserInfo } from './user.js';

const store = createStore(combineReducers({
  app, stores, auth, user
}));

const mapAllStateToProps = (state) => {
  return { 
    app   : state.app,
    stores: state.stores,
    auth  : state.auth,
    user : state.user
  }
}

const mapAllDispatchToProps = (dispatch) => {
  return {
    updateAppID : (id) => { dispatch(updateAppID  (id)) },
    updateStoreList: (listInfo) => { dispatch(updateStoreList(listInfo)) },
    updateStoreQuery: (query) => { dispatch(updateStoreQuery(query)) },
    updateAuthInfo: (info) => { dispatch(updateAuthInfo(info)) },
    cleanAuthInfo: () => { dispatch(cleanAuthInfo()) },
    updateUserInfo: (info) => { dispatch(updateUserInfo(info)) },
    cleanUserInfo: () => { dispatch(cleanUserInfo()) }
  }
}

const wConnectRedux = (component) => connect(mapAllStateToProps, mapAllDispatchToProps)(component)

export {
  store, 
  mapAllStateToProps,
  mapAllDispatchToProps,
  wConnectRedux,
}


// WEBPACK FOOTER //
// ./src/reducers/index.js